import { ThemeProvider as MUIThemeProvider } from '@material-ui/styles';
import useGlobalStyles from './useGlobalStyles';
import makeTheme from './makeTheme';
import { Theme, Customization } from './types';

const ThemeProvider: React.FC<{
    customization?: Customization;
    customTheme?: Partial<Theme>;
}> = ({ children, customization = CUSTOMIZATION_DEFAULT, customTheme }) => {
    const theme = makeTheme(customization, customTheme || {});

    useGlobalStyles();
    return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>;
};

export default ThemeProvider;
export { useGlobalStyles as useDsGlobalStyles };

//todo: do i need to do default for the tool bar as wel
export const CUSTOMIZATION_DEFAULT = {
    background: {
        C10: '#F8F7F3',
        C20: '#eae6da',
        C30: '#dfdac8',
        G10: '#272727',
        G20: '#767676',
        G30: '#DEDEDE',
        G40: '#F4F4F4',
        G50: '#FFFFFF',
    },
    surface: {
        C10: '#FFFFFF',
        C20: '#ebebeb',
        C30: '#dbdbdb',
        G10: '#272727',
        G20: '#767676',
        G30: '#DEDEDE',
        G40: '#F4F4F4',
        G50: '#FFFFFF',
    },
    interactive: {
        C10: '#404040',
        C20: '#484848',
        C30: '#4d4d4d',
        G10: '#FFFFFF',
        G20: '#F4F4F4',
        G30: '#DEDEDE',
        G40: '#767676',
        G50: '#272727',
    },
};
